import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function Footer({ onOpenCookiePrefs }) {
  const { lang } = useApp();
  const L = (it, en) => (lang === "en" ? en : it);
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/company").then((r) => setC(r.data)).catch(() => {}); }, []);
  const year = new Date().getFullYear();
  const links = [
    { to: "/privacy", label: L("Privacy Policy", "Privacy Policy") },
    { to: "/cookie-policy", label: "Cookie Policy" },
    { to: "/terms", label: L("Termini di Servizio", "Terms of Service") },
    { to: "/dpa", label: "DPA" },
  ];
  return (
    <footer className="mt-16 border-t border-border bg-muted/30" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 py-10 grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src={(c && c.logo_url) || "/logo.png"} alt="Revenue AI" className="w-8 h-8" />
            <span className="font-bold text-lg">{(c && c.brand_name) || "Revenue AI"}</span>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {c ? c.ragione_sociale : ""}
            {c && c.vat_code ? <><br />P.IVA {c.vat_code}</> : null}
            {c && c.legal_address ? <><br />{c.legal_address}</> : null}
          </p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-3">{L("Legale", "Legal")}</h4>
          <ul className="space-y-2 text-sm">
            {links.map((l) => (
              <li key={l.to}><Link data-testid={`footer-${l.to.replace("/", "")}`} to={l.to} className="hover:text-primary transition-colors">{l.label}</Link></li>
            ))}
            <li>
              <button data-testid="footer-cookie-prefs" onClick={onOpenCookiePrefs} className="hover:text-primary transition-colors text-left">
                {L("Preferenze cookie", "Cookie preferences")}
              </button>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-muted-foreground mb-3">{L("Contatti", "Contacts")}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            {c && c.support_email ? <li><a href={`mailto:${c.support_email}`} className="hover:text-primary">{c.support_email}</a></li> : null}
            {c && c.pec ? <li>PEC: {c.pec}</li> : null}
            {c && c.phone ? <li>{c.phone}</li> : null}
            {c && c.website ? <li><a href={c.website} target="_blank" rel="noreferrer" className="hover:text-primary">{c.website.replace(/^https?:\/\//, "")}</a></li> : null}
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-6xl mx-auto px-6 py-4 text-xs text-muted-foreground flex flex-wrap items-center justify-between gap-2">
          <span>© {year} {(c && c.ragione_sociale) || "Revenue AI"}. {L("Tutti i diritti riservati.", "All rights reserved.")}</span>
          <span>{(c && c.brand_name) || "Revenue AI"}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
